
import { Component, OnDestroy, OnInit,HostListener } from '@angular/core';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { NavbarService } from 'app/core/nav-items/navbar.service';
import { getFlagReminderMsg } from 'app/core/store/flagReminderMsg/flagReminderMsg.selectors';
import { getLoggedInUser } from 'app/core/store/loggedInUser/loggedInUser.selectors';
import { Store } from '@ngrx/store';
import { URLPaths } from '../common/utilities/urlPaths.config';
import { CronJob } from 'cron';
import { UserModel } from '../common/models/user.model';
import { UserService } from '../common/services/user.service';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { ConsultantModel } from '../common/models/consultant.model';
import { setUser } from 'app/core/store/currentUser/user.actions';
import { setLoggedInUser } from 'app/core/store/loggedInUser/loggedInUser.action';
import { LocalStorageService } from '../common/services/local-storage.service';
import { WriteSilenceService } from '../common/services/write-silence.service';
import { LogoutService } from '../common/services/logout.service';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { mobileHeaderItems } from 'app/shared/settings/settings.items';
import { FlagEntryService } from '../common/services/flag-entry.service';
import { ImmigrationDetailsService } from '../common/services/immigration-details.service';
import { includes } from 'lodash';
import { SessionStorageService } from '../common/services/session-storage.service';
import { SnackbarService } from '../common/services/snackbar.service';
import { MsalAuthService } from '../../../login/msal-auth.service';
import { firstValueFrom } from 'rxjs';
import { RbacService } from 'app/core/rbac/rbac.service';
import { selectPermissions } from 'app/core/store/rbac/rbac.selectors';
import { filterNavByPermissions } from 'app/core/rbac/rbac-nav.util';

@Component({
    selector: 'app-baselayout',
    templateUrl: './baselayout.component.html',
    styleUrls: ['./baselayout.component.scss']
})
export class BaselayoutComponent implements OnInit, OnDestroy
{
    flagReminderMsg: string | null;
    user: UserModel | null;
    currentUser: ConsultantModel;
    isScreenSmall: boolean;
    navigation: any[];
    isLoaded: boolean = true;
    cronJob: CronJob;
    isWriteSilence: boolean;
    beginLogoutAction: boolean = false;
    currentURL: string = '';
    mobileHeaderItems: {};
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    loggedInUserImage: string;
    showMobileSettings = false;
    currentUrl: string;
    isPlanningTimeEntry = false;
    private permissions: string[] = [];
  
    //   restrictedUrls: string[] = [
  //     URLPaths.ROUTE_PROJECT_DETAILS,

  // ];

    /**
     * Constructor
     */

    constructor(
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _navBarItemService : NavbarService,
        private _store: Store,
        private _userService: UserService,
        private _writeSilenceService: WriteSilenceService,
        private _logoutService: LogoutService,
        private _router: Router,
        private _flagEntryService: FlagEntryService,
        private _immigrationDetailsService: ImmigrationDetailsService,
        private _snackbarService: SnackbarService,
        private _msalAuthService: MsalAuthService,
        private _rbacService: RbacService
    )
    {
        this.checkScreenSize();
        this.getURL();
        this.mobileHeaderItems = mobileHeaderItems.shortcutItems;
        this._router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentURL = event["url"];
                this.updateNavigationItems();
            }
        });
        this._store.select(getLoggedInUser).subscribe((data) => {
            if(data != null){
                this.user = data;
                this.loggedInUserImage = `https://ui-avatars.com/api/?name=${this.user.first_name}+${this.user.last_name}&background=random`;
                this._userService.getUserProfilePhoto(this.user.email).toPromise().then(
                  (data)=>{
                    if(data != null){
                        this.loggedInUserImage =  data;
                    }
                  }
                );
            }
          });
          this._store.select(getCurrentUser).subscribe((data)=>{
            if(data != null){
                this.currentUser = data;
                this._immigrationDetailsService.setCountryCulture();
            }
        });
        this._writeSilenceService.writeSilence.subscribe((data)=>{
            this.isWriteSilence = data;
        })
        this._flagEntryService.getFlagEntry().subscribe();
        this._store.select(getFlagReminderMsg).subscribe((data) => {
            this.flagReminderMsg = data;
        });
        // Update navigation when RBAC permissions are loaded or changed.
        this._store.select(selectPermissions).subscribe((p) => {
            this.permissions = p;
            this.updateNavigationItems();   // re-filter when RBAC arrives
        });
                this._store.select(getCurrentUser).subscribe((data) => {
          this.currentUser = data;
          if (this.currentUser) {  // Only get flag entry when we have user data
              this._flagEntryService.getFlagEntry().subscribe();
          }
      });

        // intialising the web worker
        if (typeof Worker !== 'undefined') {
            const worker = new Worker(new URL('../worker/write-listener.worker', import.meta.url));
            this.cronJob = new CronJob('*/10 * * * * *', async () => {
                try {
                    let token = await firstValueFrom(this._msalAuthService.getValidTokenProactively());
                    if (!token) {
                        token = LocalStorageService.getLocalStorageValueBasedOnKeys('MSAL_JWT_TOKEN') || LocalStorageService.getLocalStorageValueBasedOnKeys('API_KEY');
                    }
                    if (!token) return;
                    const postData = {
                        workerURL : URLPaths.URL_WRITE_SILENCE,
                        authorisation: 'Bearer ' + token
                    };
                    worker.postMessage(postData);

                } catch (e) {
                  console.error(e);
            }});
                // Start job
            if (!this.cronJob.running) {
                    this.cronJob.start();
            }
            worker.onmessage = ({ data }) => {
              if (data && data["status"] !== undefined) {
                this._writeSilenceService.writeSilence.next(data["status"]);
              }
            };
            this._logoutService.beginLogoutAction.subscribe((data)=>{
                if(data){
                    this.cronJob.stop();
                }
            })
          } else {
            // Web workers are not supported in this environment.
            // You should add a fallback so that your program still executes correctly.
          }
    }

    async getURL(){
    this._router.events.pipe(
        filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects; // Get the final URL after redirects
        this.isPlanningTimeEntry = this.currentUrl.includes(
            URLPaths.ROUTE_PLANNING + URLPaths.ROUTE_PLANNING_TIME_ENTRY
        );
       // Filter navigation items based on the user's permissions..
        this.navigation = filterNavByPermissions(
            this._navBarItemService.getNavItemsBlueprintData(),
            this.permissions
        );
              // Check if user has finance permissions
              // OLD (replaced by RBAC): the isFinanceUser block that pushed into analyticsGroup.children
        /*if (SessionStorageService.getSessionStorageValueBasedOnKeys('isFinanceUser') === 'true') {
          // Find the analytics group (assuming it's at index 1 based on your nav structure)
          const analyticsGroup = this.navigation.find(item => item.id === 'analytics');

          if (analyticsGroup && analyticsGroup.children) {
              // Check if finance-expense item already exists
              const financeItemExists = analyticsGroup.children.some(child => child.id === 'finance-expense');

              // Add the finance-expense item if it doesn't already exist
              if (!financeItemExists) {
                  analyticsGroup.children.push({
                      id: 'finance-expense',
                      title: 'Expense',
                      type: 'basic',
                      icon: 'pie_chart',
                      link: URLPaths.ROUTE_FINANCE_EXPENSE
                  });
              }
          }
      }*/
    
        console.log(this.navigation)
        this.navigation[3].children[0].active = this.currentUrl.includes(URLPaths.ROUTE_PROJECT_DETAILS);
    });
}

    // Listen for window resize events
    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
      this.checkScreenSize();
    }

    // Function to check the screen size and toggle the showMobileSettings flag
    checkScreenSize(): void {
      // Adjust the breakpoint as needed
      const wasSMall = this.showMobileSettings;
      this.showMobileSettings = window.innerWidth <= 768;
      if(wasSMall !== this.showMobileSettings){

        this.updateNavigationItems();
      }
    }

   updateNavigationItems(): void {
    const raw = this.showMobileSettings
        ? this._navBarItemService.getNavItemsMobileBlueprintData()
        : this._navBarItemService.getNavItemsBlueprintData();
    this.navigation = filterNavByPermissions(raw, this.permissions);
}
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to media changes

        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
                this.checkScreenSize();
            });

        // this.navigation = this._navBarItemService.getNavItemsBlueprintData();
        // this.checkScreenSize();
        
        // Load RBAC permissions when the layout initializes.  
        this._rbacService.ensureLoaded().pipe(takeUntil(this._unsubscribeAll)).subscribe();

    }

    setCurrentUser(user: ConsultantModel) {
        this._store.dispatch(setUser({ user }));
    }
    setLoggedInUser(user: UserModel ) {
        this._store.dispatch(setLoggedInUser({ user }));
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        if (this.cronJob) {
            this.cronJob.stop();
        }
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
